import BlogArticleCardSkeleton from '@components/skeletons/articleCardSkeleton.b1';
import { distinctUntilChanged, filter, map, skip } from 'rxjs';
import { store$ } from '@redux/store';
import { selectPageSize,
  onSuccesedArticleSearchResults$, onloadingArticleSearchResults$ } from 'features/articleSearchResultsFacets';

const skeleton = new BlogArticleCardSkeleton();
skeleton.setContainer('[data-component="article-search-results"]');
skeleton.setCardCounts(20);

const removeBlogArticleCardSkeletons = function() {
  skeleton.destroy()
};

const renderBlogArticleCardSkeletons = function() {
  skeleton.create();
};

const updateBlogArticleCardCountSkeleton = function(pageSize) {
  skeleton.setCardCounts(pageSize);
}

// observer to map search command but only emmit if the page have been changed
const onPageSizeChange$ = store$.pipe(
  map(selectPageSize),
  filter(Boolean),
  distinctUntilChanged(),
  skip(1)
);

onPageSizeChange$.subscribe(updateBlogArticleCardCountSkeleton);
onloadingArticleSearchResults$.subscribe(renderBlogArticleCardSkeletons);
onSuccesedArticleSearchResults$.subscribe(removeBlogArticleCardSkeletons);